import React, { createContext, useContext, useState } from "react";

const SearchContext = createContext(null);
export const useSearch = () => useContext(SearchContext);

export const SearchProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <SearchContext.Provider value={{ open, setOpen }}>
      {children}
    </SearchContext.Provider>
  );
};
